import { render } from "./NotificationBell.vue?vue&type=template&id=25a13ff9"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/NotificationBell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25a13ff9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25a13ff9', __exports__)) {
    console.log('reload')
    api.reload('25a13ff9', __exports__)
  }
  
  module.hot.accept("./NotificationBell.vue?vue&type=template&id=25a13ff9", () => {
    console.log('re-render')
    api.rerender('25a13ff9', render)
  })

}


export default __exports__